import React from "react";
import PagesBanner from "./PagesBanner";
import Contact from "../Contact Us/Contact";

const ContactUsPage = () => {
  return <>
    <PagesBanner title={'Contact Us'} />
    <Contact />
  </>;
};

export default ContactUsPage;
